import { memo } from 'react'
import styled from 'styled-components'
import { ButtonMenu, ButtonMenuItem, LinkExternal, Flex, Svg, Image, Button } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { EXCHANGE_DOCS_URLS } from 'config/constants'

const Wrapper = memo(styled.div<{ $isSide: boolean }>`
  width: 100%;
  height: ${({ $isSide }) => ($isSide ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  padding-top: 16px;
  padding-right: ${({ $isSide }) => ($isSide ? '32px' : '0px')};
  ${({ theme }) => theme.mediaQueries.md} {
    justify-content: space-between;
    flex-direction: ${({ $isSide }) => ($isSide ? 'column' : 'row')};
  }
`)

const WrapperContainer = styled(Flex)`
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
    padding-bottom: 100px;
    img{
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
    }
    h6{
        font-weight: 900;
        font-style: normal;
        margin-top: -1px;
        text-align: center;
        line-height: 70px;
        white-space: nowrap;
        font-size: 60px;
        color: ${({theme}) => theme.colors.white};
        font-family: "Inter",Helvetica;
        @media screen and (max-width: 600px){
            font-size: 36px;
        }
    }
    p{
        color:#5e6b7e;
        span{
            color:#fff;
        }
    }
`
const CsClipPath = styled.div`
    background-color: #fff;
    padding: 2px;
    -webkit-clip-path: polygon(0px 0%,calc(100% - 15px) 0%,100% 12px,100% calc(100% - 0px),calc(100% - 0px) 100%,20px 100%,0 calc(100% - 0px));
    clip-path: polygon(
        0px 0%,
        calc(100% - 15px) 0%,
        100% 12px,
        100% calc(100% - 0px),
        calc(100% - 0px) 100%,
        20px 100%,
        0 calc(100% - 0px)
    );
    border-radius: 5px;
    cursor: pointer;
    div{
        background: #0081e2;
        padding: 10px 15px;
        clip-path: polygon(0px 0%,calc(100% - 15px) 0%,100% 12px,100% calc(100% - 0px),calc(100% - 0px) 100%,20px 100%,0 calc(100% - 0px));
        display: block;
        color: #fff;
        font-weight: 600;
    }
`

type FooterVariant = 'default' | 'side'

const Footer: React.FC<React.PropsWithChildren<{ variant?: FooterVariant; helpUrl?: string }>> = ({
    variant = 'default',
    helpUrl = EXCHANGE_DOCS_URLS,
}) => {
    return (
        <WrapperContainer>
            <img src="/images/base_img/poolImg.png?version=1.0" alt="" />
            <h6>Want to join us?</h6>
            <p>Learn more from our <span>Whitepaper.</span></p>
            <CsClipPath>
                <div>
                    <p style={{ color: "#ecdede" }}>
                        JOIN THE COMMUNITY
                    </p>
                </div>
            </CsClipPath>
        </WrapperContainer >
    )
}

export default memo(Footer)
